import React from "react";
import VidaAcademica from "../../components/VidaAcademica";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return (
    <>
      <div id="main">
      <VidaAcademica />
      </div>
    </>
  );
};
